import { palette, animations } from '../../theme';

export const mobileMonthPickerStyles = {
  wrapper: {
    width: '100%',
    height: '500px',
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    overflowY: 'auto' as const,
    paddingBottom: '40px',
    ...animations.appearanceEffect,
  },

  yearHeader: {
    padding: '16px 0 8px 0',
    textAlign: 'center' as const,
    fontFamily: 'Rubik, sans-serif',
    fontWeight: 'bold',
    fontSize: '18px',
    color: palette.primary.main,
  },

  monthButton: {
    minWidth: '80px',
    height: '40px',
    margin: '4px',
    fontSize: '14px',
    fontWeight: 'normal',
    borderRadius: '8px',
    textTransform: 'uppercase' as const,
    border: 'none',
    backgroundColor: 'transparent',
    color: palette.text.primary,
    '&:hover': {
      backgroundColor: palette.grey[100],
    },
  },

  selectedMonthButton: {
    minWidth: '80px',
    height: '40px',
    margin: '4px',
    fontSize: '14px',
    borderRadius: '8px',
    textTransform: 'uppercase' as const,
    border: 'none',
    backgroundColor: palette.primary.main,
    color: palette.background.paper,
    fontWeight: 'bold',
    '&:hover': {
      backgroundColor: palette.primary.main,
    },
  },

  yearContainer: {
    width: '100%',
    marginBottom: '24px',
  },

  monthsGrid: {
    display: 'flex',
    flexWrap: 'wrap' as const,
    justifyContent: 'center',
    maxWidth: '400px',
    gap: '8px',
  },

  monthGridItem: {
    flex: '0 0 calc(25% - 6px)',
    minWidth: '80px',
  },
};
